import { Dialog, DialogContent, Slide } from "@mui/material";
import React from "react";
import TinodeChatDoctor from "../telemedicine/tinodeChat/TinodeChatDoctor";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ModalChatCustomer = ({ openChat, setOpenChat, drugData }) => {
  const user = {
    fullname: localStorage.getItem("fullname") || "User",
    email: localStorage.getItem("email") || "",
    id: localStorage.getItem("user_id") || "",
    userid_tinode: localStorage.getItem("user_id") || "",
  };

  return (
    <Dialog
      open={openChat}
      TransitionComponent={Transition}
      onClose={() => {
        setOpenChat(false);
      }}
      PaperProps={{
        sx: {
          position: "absolute",
          bottom: -16,
          right: 8,
          borderRadius: "1rem 1rem 0 0",
          margin: "1rem",
          maxWidth: "calc(100% - 1rem)",
          height: "100%",
          width: "70%",
        },
      }}
    >
      <DialogContent
        sx={{
          padding: 0,
          height: "100%",
          overflow: "hidden",
        }}
      >
        <TinodeChatDoctor user={user} drugData={drugData} />
      </DialogContent>
    </Dialog>
  );
};

export default ModalChatCustomer;
